import { Select, SelectProps } from '@mantine/core';
import styled from '@emotion/styled';

const StyledSelect = styled(Select)`
   & .mantine-Select-input {
      border: none;
      background: none;
   }
`;

export default function ({ searchable, ...props }: SelectProps) {
   return <StyledSelect {...props} searchable={searchable === undefined ? true : searchable} />;
}
